<template>
	<footer class="relative z-20 pb-10">
		<h5 class="text-black font-bold text-3xl mx-auto w-max uppercase">Carlos Pereira</h5>
		<h6 class="text-black font-thin text-sm mx-auto text-center"
			style="max-width: 98%;">{{ $t("footer.caption") }}</h6>

		<Social-Networks class="mx-auto w-max" />
	</footer>
</template>

<script>
import SocialNetworks from '@/components/SocialNetworks'

export default {
	name: 'Footer',

	components: { SocialNetworks },
}
</script>